{
  "bliksy": {
    "inputPlaceholder": "Kérdezzen bármit",
    "disclaimer": "A BLIKSY mesterséges intelligenciával támogatott, és hibákat tartalmazhat. Kérjük, ellenőrizze a válaszokat.",
    "resizeHandle": "Csevegőpanel átméretezése"
  },
  "voiceInput": {
    "startRecording": "Hangfelvétel indítása",
    "stopRecording": "Felvétel leállítása",
    "cancelRecording": "Felvétel megszakítása",
    "transcribing": "Átírás...",
    "microphoneDenied": "A mikrofonhoz való hozzáférés megtagadva.",
    "recordingFailed": "A felvétel nem sikerült. Kérjük, próbálja újra.",
    "transcriptionFailed": "Nem sikerült a hanganyag átírása. Kérjük, próbálja újra."
  },
  "chat": {
    "sendMessage": "Üzenet küldése",
    "transcript": "Csevegés átirata",
    "messageFailed": "Ez az üzenet nem jeleníthető meg.",
    "retry": "Újrapróbálkozás",
    "sourcesLabel": "Források",
    "chart": {
      "loading": "Diagram előkészítése…",
      "failed": "A diagramot nem sikerült létrehozni.",
      "hoursSuffix": "{{value}} ó",
      "percentSuffix": "{{value}}%",
      "coverageOmitted": "{{requested}} bejegyzésből {{omitted}} nem jelenik meg.",
      "coverageTruncated": "Csak a legnagyobb {{rendered}} bejegyzés jelenik meg.",
      "pointLabels": {
        "restricted": "Nincs hozzáférés",
        "unknown": "Ismeretlen",
        "unassigned": "Nincs hozzárendelve"
      }
    },
    "diagram": {
      "label": "Diagram",
      "loading": "Diagram előkészítése…",
      "failed": "A diagramot nem sikerült megjeleníteni.",
      "expand": "Diagram nagyítása",
      "zoomIn": "Nagyítás",
      "zoomOut": "Kicsinyítés",
      "resetZoom": "Nézet visszaállítása"
    },
    "document": {
      "preparing": "Fájl előkészítése…",
      "failed": "A fájlt nem sikerült létrehozni.",
      "download": "Fájl letöltése",
      "rows": "{{rows}} sor · elérhető eddig: {{expiry}}",
      "partialRows": "Az első {{rows}} sor · elérhető eddig: {{expiry}}",
      "rowsOnly": "{{rows}} sor",
      "partialRowsOnly": "Az első {{rows}} sor",
      "omitted": "{{omitted}} sor nem szerepel a fájlban.",
      "expired": "Ez a fájl már nem érhető el.",
      "downloadFailed": "A letöltést nem sikerült elindítani."
    },
    "entityView": {
      "loading": "Nézet előkészítése…",
      "unavailable": "Ez a nézet már nem érhető el.",
      "noDecisionRules": "Ennek a lépésnek már nincs döntési táblázata.",
      "loadFailed": "A nézetet nem sikerült betölteni.",
      "current": "Jelenlegi állapot",
      "updatedAt": "Frissítve: {{date}}",
      "untitledStep": "Névtelen lépés",
      "openProcess": "Folyamat megnyitása",
      "openFullscreen": "Teljes képernyő megnyitása",
      "exitFullscreen": "Kilépés a teljes képernyőből"
    },
    "entityCard": {
      "loading": "Részletek betöltése…",
      "unavailable": "Ez a bejegyzés már nem érhető el.",
      "loadFailed": "A részleteket nem sikerült betölteni."
    },
    "attachment": {
      "fallbackName": "Fájl",
      "label": "Csatolt fájl",
      "attach": "Fájl csatolása",
      "remove": "Melléklet eltávolítása",
      "dropHint": "Húzzon ide egy PDF-fájlt vagy képet",
      "uploading": "Feltöltés folyamatban...",
      "tooMany": "Üzenetenként legfeljebb {{max}} fájl",
      "unsupported": "Csak PDF-, PNG- vagy JPEG-fájlok",
      "tooLarge": "Legfeljebb {{maxMegabytes}} MB",
      "uploadFailed": "A feltöltés sikertelen"
    },
    "feedback": {
      "thumbsUp": "Hasznos",
      "thumbsDown": "Nem hasznos",
      "commentTitle": "Mi volt a baj ezzel a válasszal?",
      "commentPlaceholder": "Írja le, mi nem stimmelt",
      "commentSend": "Küldés",
      "error": "A visszajelzést nem sikerült menteni."
    }
  },
  "thinkingPhases": {
    "stepSummary": {
      "start1": "Feladat elemzése…",
      "middle1": "Összegzés készítése…",
      "end1": "Szöveg finomítása…"
    },
    "chat": {
      "start1": "Kérdés olvasása…",
      "start2": "Kérdés értelmezése…",
      "middle1": "Releváns információk keresése…",
      "middle2": "Források ellenőrzése…",
      "middle3": "Folyamatmodell vizsgálata…",
      "end1": "Válasz megfogalmazása…",
      "end2": "Szöveg csiszolása…"
    }
  }
}
